import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";

import { getLoggedInUser } from '../../helpers/auth_helper';

const useProfile = () => {
  const navigate = useNavigate();

  const userProfileSession = getLoggedInUser();
  var token = userProfileSession && userProfileSession['token'];
  const [loading, setLoading] = useState(userProfileSession ? false : true);
  const [userProfile, setUserProfile] = useState(userProfileSession ? userProfileSession : null);
  useEffect(() => {
    const userProfileSession = getLoggedInUser();
    var token = userProfileSession && userProfileSession['token'];
    // 验证token
    try {
      if (!token) {
        navigate('/login');
      }
      // 解析token
      const parts = token.split('.');
      if (parts.length !== 3) {
        console.error('Token格式不正确',parts);
        return;
      }

      const decodedPayload = jwtDecode(token);

      const currentTime = Math.floor(Date.now() / 1000); // 当前时间戳（秒）

      if (decodedPayload.exp < currentTime) {
        // 如果token已过期
        console.log('token 已过期');
        navigate('/login');
      } else {
        setUserProfile(userProfileSession ? userProfileSession : null);
        setLoading(token ? false : true);
      }
    } catch (error) {
      // 如果token验证失败
      console.log('token 验证失败',error);
      navigate('/login');
    }
  }, [navigate]);

  return { userProfile, loading, token };
};

export { useProfile };
